// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mj-0";
export var buttonContainer = "_mj-3";
export var cancelButton = "_mj-4";
export var headerSection = "_mj-6";
export var headerTitle = "_mj-9";
export var messageSideLeft = "_mj-1";
export var messageSideRight = "_mj-2";
export var orderNumberContainer = "_mj-7";
export var orderNumberLabel = "_mj-8";
export var submitButton = "_mj-5";